<template>
  <div class="text-h6 text-center q-pa-md shadow rounded">
    {{ $t('PO') + ': ' + data.id }}
  </div>
</template>

<script>
export default {
  name: 'AcceptanceObject',
  props: {
    data: {
      type: Object,
      default () {
        return null
      }
    }
  }
}
</script>
